import { z } from 'zod';
import { ADMIN_PASSWORD_MIN_LENGTH, ADMIN_PASSWORD_REGEX } from '@ooh/contracts';

// Built from the SAME ADMIN_PASSWORD_MIN_LENGTH / ADMIN_PASSWORD_REGEX
// constants that CreateUserSchema / AdminSetPasswordSchema use in
// packages/contracts/src/schemas/user-admin.ts, with a translated message.
// Those contracts schemas stay the server-side/API source of truth and are
// still enforced there -- this client-only copy exists so the min-length and
// digit/symbol validation errors render in the active UI language instead of
// Zod's raw English defaults from the neutral contracts package.
//
// Shared by create-user-dialog.tsx and set-password-dialog.tsx -- keep this
// as the only place the password field rule is built on the web side.
export function createPasswordFieldSchema(messages: {
  minLength: string;
  requiresNumberOrSymbol: string;
}) {
  return z
    .string()
    .min(ADMIN_PASSWORD_MIN_LENGTH, messages.minLength)
    .regex(ADMIN_PASSWORD_REGEX, messages.requiresNumberOrSymbol);
}
